import styles from './PspConflictTable.module.css';

export default function PspConflictTable({
  rows,
}: {
  rows: Array<{ keyLabel: string; ids: Array<string | number> }>;
}) {
  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            <th className={styles.headerCell}>PSP Key</th>
            <th className={styles.headerCell}>Linked IDs</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c, idx) => (
            <tr key={idx}>
              <td className={styles.dataCell}>{c.keyLabel}</td>
              <td className={styles.dataCell}>{c.ids.join(', ')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
